import React from 'react';
import PropTypes from 'prop-types';
import { ConfigsService as GeneralConfigsService, LocaleService } from '@sm360/widget-commons-core-services';
import { CONSTANT, REDIRECTIONS, ADOBE_TAGS, AdobeService } from '@sm360/widget-commons-general';
import { VehicleConstants } from '@sm360/widget-commons-vehicle';

const GarageCTA = ({ isNewEnabled, isUsedEnabled, usedUrl, hasAdobeTagging }) => {
    const locale = LocaleService.getSimpleLocale();
    const isShowroomV25Enable = GeneralConfigsService.isShowroomV25Enabled();
    const catalogUrl = isShowroomV25Enable ? REDIRECTIONS[locale].catalogNew : REDIRECTIONS[locale].catalog;
    const listingUsedUrl = usedUrl !== '' ? usedUrl : REDIRECTIONS[locale].listingPreOwnedUsed;

    const handleClick = (vehicleCondition) => {
        if (hasAdobeTagging) {
            AdobeService.eventTrigger(
                ADOBE_TAGS.TRANSACTION_BAR_CTA(
                    CONSTANT.TRANSACTION.GARAGE.TITLE,
                    vehicleCondition === VehicleConstants.VEHICLE_CONDITION.NEW
                        ? CONSTANT.TRANSACTION.GARAGE.CTA.NEW
                        : CONSTANT.TRANSACTION.GARAGE.CTA.USED
                ),
                'global-onclick'
            );
            AdobeService.eventTrigger(
                ADOBE_TAGS.GARAGE_OVERLAY_CTA(
                    vehicleCondition === VehicleConstants.VEHICLE_CONDITION.NEW
                        ? CONSTANT.TRANSACTION.GARAGE.CTA.NEW
                        : CONSTANT.TRANSACTION.GARAGE.CTA.USED,
                    {}
                ),
                'global-overlay'
            );
        }
    };

    const addNewVehicleLink = (isNewEnabled || isShowroomV25Enable) && (
        <a
            className="add-car-add-vehicle sr-button-outline-1"
            href={catalogUrl}
            onClick={() => handleClick(VehicleConstants.VEHICLE_CONDITION.NEW)}
        >
            {LocaleService.t('GARAGE.ADD_VEHICLE_NEW_TITLE')}
        </a>
    );

    const addUsedVehicleLink = (isUsedEnabled || isShowroomV25Enable) && (
        <a
            className="add-car-add-vehicle sr-button-outline-1"
            href={listingUsedUrl}
            onClick={() => handleClick(VehicleConstants.VEHICLE_CONDITION.USED)}
        >
            {LocaleService.t('GARAGE.ADD_VEHICLE_USED_TITLE')}
        </a>
    );

    return (
        <div className="payment-CTA">
            {addNewVehicleLink}
            {addUsedVehicleLink}
        </div>
    );
};

GarageCTA.displayName = 'GarageCTA';

GarageCTA.propTypes = {
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
    hasAdobeTagging: PropTypes.bool,
};

GarageCTA.defaultProps = {
    hasAdobeTagging: false,
};

export default GarageCTA;
